/** Single source for the business phone number across every CTA. */
export const PHONE_DISPLAY = '818-381-9905';
export const PHONE_HREF = 'tel:8183819905';

type GtagWindow = Window & {
  gtag?: (...args: unknown[]) => void;
};

/** Fires the existing Google Ads call-conversion event, if gtag is loaded. */
export function trackCallConversion() {
  const w = window as GtagWindow;
  if (typeof w.gtag === 'function') {
    w.gtag('event', 'conversion', {
      send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
    });
  }
}
